import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ChatServices } from '@app/services/chat.service';
import { IChat } from '@common/models/Chat/IChat';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { IESGDocuments, IResponseESGFilters, ISourceURL } from '@common/models/Document/IESGDocuments';
import { ITableTag } from "@common/models/ITags";
import { ITableRow } from '@common/models/Document/ITableRow';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-esg-filters',
  templateUrl: './esg-filters.component.html',
  styleUrls: ['./esg-filters.component.scss']
})
export class EsgFiltersComponent implements OnInit, OnDestroy, OnChanges {
  selectedESGTags : ITableTag[] = [];
  selectedESGSourceType : ISourceURL[] = [];
  selectedESGDocumentName : ISourceURL[] = [];
  ESGtagsList :ITableTag[] = [];
  ESGSourcesList : ISourceURL[] = [];
  ESGDocumentNameList : ISourceURL[] = [];
  ESGOriginalSourcesList : ISourceURL[] = [];
  ESGOriginalDocumentNameList : ISourceURL[] = [];
  getESGTableTagsSubscription: Subscription = new Subscription();
  isESGFilterLoading :boolean = true;
  @Input() sidebarVisible: boolean = false;
  @Input() selectedTables: IDeltaTable[] = [];
  activeChat: IChat;
  @Output() emitSelectedFilters: EventEmitter<Record<string,any>> = new EventEmitter();
  summaryData: string = '';
  headerSummary: string ='';
  dialogType: string;
  summaryDocumentName: string =''
  getESGDocsSub: Subscription = new Subscription();
  summarySidebarVisible: boolean = false;
  ESGDocumentLoaderDocs : Record<number,boolean> = {}


  constructor(public chatService: ChatServices) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.getESGTableTagsSubscription && this.getESGTableTagsSubscription.unsubscribe();
    this.getESGDocsSub && this.getESGDocsSub.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.summarySidebarVisible = false
    if(changes['sidebarVisible']?.currentValue===true){
      this.activeChat = this.chatService.getActiveChat();
      this.selectedESGTags = []
      this.selectedESGSourceType = []
      this.selectedESGDocumentName = []
      if(this.activeChat?.ESGTableTags){
        this.selectedESGTags = [...this.activeChat.ESGTableTags.map((e:ITableTag)=>{return {'tag':e.tag}})]
      }
      if(this.activeChat?.chatConfig?.ESGChat){
        this.selectedESGSourceType = [...this.activeChat.chatConfig.ESGChat.ESGSources.map((e:ISourceURL)=>{return {'sourceType':e.sourceType}})]
        this.selectedESGDocumentName = [...this.activeChat.chatConfig.ESGChat.ESGDocuments.map((e:ISourceURL)=>({'sourceType' : e.sourceType,'documentPath':e.documentPath,'documentName':e.documentName,'documentId':e.documentId}))]
      }
      if(this.ESGSourcesList.length == 0 || this.ESGDocumentNameList.length == 0 || this.ESGtagsList.length==0){
        this.getESGTableTags();
      }
    }
  }

  async getESGTableTags(){
    this.isESGFilterLoading = true
      this.getESGTableTagsSubscription.add(
        this.chatService
            .getESGDocuments()
            .subscribe({
                next: (
                    table: IResponseESGFilters
                ) => {
                    this.isESGFilterLoading = false
                    if (table.sourceURL) {
                      this.filterUniqueSourceTypes(table.sourceURL)
                      this.ESGDocumentNameList = table.sourceURL.map((e:IESGDocuments)=>{return {'sourceType' : e.sourceType,'documentPath':e.documentPath,'documentName':e.documentName,'documentId' : e.documentId}});
                      this.ESGOriginalDocumentNameList =  _.cloneDeep(this.ESGDocumentNameList);
                    }
                    if ( table.documentTags) {
                      this.ESGtagsList = []
                      let tags : any = table.documentTags
                        tags.map((e:ITableTag,i:number)=>{
                            this.ESGtagsList.push({tag:e.tag})
                        })
                      }
                },
                error: (
                    error
                ) => {
                },
            })
    );
  }

  filterUniqueSourceTypes(SourceUrls : IESGDocuments[]){
    const uniqueSourceTypes = new Set<string>();
    this.ESGSourcesList = []
    this.ESGOriginalSourcesList = []
    SourceUrls.forEach((doc : IESGDocuments) => {
        if (!uniqueSourceTypes.has(doc.sourceType)) {
            uniqueSourceTypes.add(doc.sourceType);
            this.ESGSourcesList.push({'sourceType':doc.sourceType});
            this.ESGOriginalSourcesList.push({'sourceType':doc.sourceType});
        }
    });
  }

  onMultiSelectOpen(){
    if(this.activeChat?.ESGTableTags?.length>0 && this.selectedESGTags.length === 0){
      this.selectedESGTags = []
      this.activeChat.ESGTableTags.map((e:ITableTag)=>{
        this.selectedESGTags = [...this.selectedESGTags,...[{tag:e.tag}]]
      })
    }
  }

  updateFiltersSource(isClear?:boolean){
    if(isClear){
      this.selectedESGSourceType = []
    }
      if (this.selectedESGSourceType.length > 0) {
          let sourceList: string[] = this.selectedESGSourceType.map((e: ISourceURL) => e.sourceType);
          this.ESGDocumentNameList = this.ESGOriginalDocumentNameList.filter(e => sourceList.includes(e.sourceType));
          if(this.selectedESGDocumentName.length > 0){
            this.selectedESGDocumentName = [...[],...this.selectedESGDocumentName.filter(e => sourceList.includes(e.sourceType))]
          }
      }else{
        this.ESGDocumentNameList = this.ESGOriginalDocumentNameList
      }
  }

  updateFiltersDocuments(isClear?:boolean){
    if(isClear){
      this.selectedESGDocumentName = []
    }
    if(this.selectedESGDocumentName.length > 0){
      let sourceList: string[] = Array.from(new Set(this.selectedESGDocumentName?.map((e: ISourceURL) => e.sourceType)));
      let selectedSourceList :string[] = Array.from(new Set(this.selectedESGSourceType?.map((e: ISourceURL) => e.sourceType)));
      this.selectedESGSourceType = [
        ...this.selectedESGSourceType,
        ...sourceList
          .filter((source: string) => !selectedSourceList.includes(source))
          .map((source: string) => ({ sourceType: source }))
      ];
      // this.ESGSourcesList = this.ESGOriginalSourcesList.filter(e => sourceList.includes(e.sourceType));
    }else{
      this.ESGSourcesList = this.ESGOriginalSourcesList
    }
  }

  addDocs(){
    if(this.selectedESGSourceType.length > 0 && this.selectedESGDocumentName.length == 0){
      let sourceList: string[] = Array.from(new Set(this.selectedESGSourceType.map((e: ISourceURL) => e.sourceType)));
      this.ESGOriginalDocumentNameList.map((e:ISourceURL)=>{
        if(sourceList.includes(e.sourceType)){
          this.selectedESGDocumentName.push(e)
        }
      })
    }
    this.emitSelectedFilters.emit({
      'Tags' : this.selectedESGTags,
      'SourceType' : this.selectedESGSourceType?.map((e:ISourceURL)=>({'sourceType' : e.sourceType})),
      'DocumentName' : this.selectedESGDocumentName?.map((e:ISourceURL)=>({'sourceType' : e.sourceType,'documentPath':e.documentPath,'documentName':e.documentName,'documentId':e.documentId})),
    })
  }

  handleIconClick(event: MouseEvent, option: IESGDocuments): void {
    event.preventDefault();
    event.stopPropagation();

    // Use setTimeout to ensure this runs after the current event cycle
    setTimeout(() => {
      this.openESGSummary(option);
    }, 0);
  }

  preventOptionClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }


  openESGSummary(ESGDocument:IESGDocuments){
    this.headerSummary = 'Summary'
    this.dialogType = 'sideBar';
    this.summaryDocumentName = ESGDocument.documentName
    this.getESGDocsSub = this.chatService.getESGDocumentByID(ESGDocument.documentId)
      .subscribe({
          next: (res: IESGDocuments) => {
            this.ESGDocumentLoaderDocs = {}
            this.summaryData = res.documentSummary
            this.summarySidebarVisible = true;
          }
      });
  }

  updateSidebar(value: boolean) {
    this.summarySidebarVisible = value;
  }

}
